'use strict';

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/icon/style/css.js
// module id = 372
// module chunks = 127